﻿export function initLanguageDropdown() {
    const dropdown = document.querySelector("[data-language-dropdown]");
    if (!dropdown) return;

    const toggle = dropdown.querySelector("[data-language-toggle]");
    const menu = dropdown.querySelector("[data-language-menu]");

    if (!toggle || !menu) return;

    toggle.addEventListener("click", (e) => {
        e.stopPropagation();

        const isHidden = menu.hasAttribute("hidden");
        if (isHidden) {
            menu.removeAttribute("hidden");
            dropdown.classList.add("is-open");
        } else {
            menu.setAttribute("hidden", "");
            dropdown.classList.remove("is-open");
        }
    });

    document.addEventListener("click", (e) => {
        if (!dropdown.contains(e.target)) {
            menu.setAttribute("hidden", "");
            dropdown.classList.remove("is-open");
        }
    });

    document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") {
            menu.setAttribute("hidden", "");
            dropdown.classList.remove("is-open");
        }
    });
}